import React from "react";
import "./PaymentSuccessModal.css";

const PaymentSuccessModal = ({ isVisible, bookingId, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className="payment-success-overlay">
      <div className="payment-success-modal">
        {/* Celebratory confetti burst */}
        <div className="confetti-container" aria-hidden="true">
          {Array.from({ length: 24 }).map((_, i) => (
            <span key={i} className="confetti-piece" style={{ "--i": i }} />
          ))}
        </div>
        <div className="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="checkmark">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
          </svg>
        </div>
        <h3>Payment Successful!</h3>
        <p>Your booking has been confirmed</p>
        <div className="booking-id">
          <span>Booking ID: </span>
          <strong>{bookingId}</strong>
        </div>
        <p className="redirect-text">Redirecting to your ticket...</p>
        <div className="loading-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessModal; 